import { AppointmentStatus } from "types";

type Colors = { background: string; color: string };
type StatusColorsMap = Record<AppointmentStatus, Colors>;

const STATUS_COLORS: StatusColorsMap = {
  upcoming: { background: "#e3f2fd", color: "#1565c0" },
  completed: { background: "#e8f5e9", color: "#2e7d32" },
  "result pending": { background: "#e8f5e9", color: "#2e7d32" },
  started: { background: "#e3f2fd", color: "#1565c0" },
  missed: { background: "#ffebee", color: "#c62828" },
  cancelled: { background: "#eceff1", color: "#37474f" },
};

export { STATUS_COLORS };
